import { UserRef } from '@cibo/core'
import { GridValueFormatterParams } from '@mui/x-data-grid-pro'
import { FieldColumnProps } from './types'

export const fieldGrowerColumn = ({ t, ...columnProps }: FieldColumnProps) => ({
  field: 'ownedBy',
  headerName: t('Grower', { ns: 'clientLocalization' }),
  flex: 1,
  minWidth: 200,
  sortable: false,
  valueFormatter: ({ value }: GridValueFormatterParams<UserRef | undefined>) =>
    !!value
      ? !!value.familyName || !!value.givenName
        ? `${value.givenName} ${value.familyName}`
        : value.userPrimaryEmail
      : null,
  ...columnProps,
})
